module.exports = __webpack_public_path__ + "static/assets/96c5fa85ae6e9f4f2ef2ddb04ecfc90f.png";